export function isProduction() {
  const url = window.location.href;
  return process.env.NODE_ENV === 'production' && url.includes('admin.hitch.net');
}

// When running locally (react-scripts start sets NODE_ENV='development'), default
// to the staging backend so contributors work against safe test data and never
// touch live production data by accident. A deliberate choice via the in-app
// environment switcher is still respected. The hosted production build is
// unaffected (isProduction() short-circuits above).
function defaultEnvironment() {
  return process.env.NODE_ENV === 'development' ? 'staging' : 'production';
}

export function getEnvironment() {
  return isProduction()
    ? 'production'
    : localStorage.getItem('hitch-environment') || defaultEnvironment();
}

export function setEnvironment(environment) {
  if (isProduction()) {
    return;
  }

  localStorage.setItem('hitch-environment', environment);
}
